// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2_zdT","error":"Textarea_error__1uJz5","readonly":"Textarea_readonly__6BIE8","disabled":"Textarea_disabled__1o-h2"};